/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Protocol_ChangedInputs */



/**
* | output |
* | --- |
* | "This endpoint speaks a different API than the connection's models. Add it as a new connection." |
*
* @param {Private_Models_Save_Protocol_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_protocol_changed = /** @type {((inputs?: Private_Models_Save_Protocol_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Protocol_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Endpunkt spricht eine andere API als die Modelle der Verbindung. Legen Sie ihn als neue Verbindung an.")
	return /** @type {LocalizedString} */ ("This endpoint speaks a different API than the connection's models. Add it as a new connection.")
});